import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Vehicle, VehicleTypeResponse, VehiclesResponse } from '../../../services/http/vehicles/vehicles.interface';
import { VehiclesService } from '../../../services/http/vehicles/vehicles.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert/alert.service';
import { Alert, AlertType } from '../../../services/alert/alert.interface';
import { FormsModule } from '@angular/forms';
import { Exception, ExceptionStatus } from '../../../services/http/exceptions/exceptions.interface';
import { AccessVehicleResponse } from '../../../services/http/access/access.interface';
import { StatusTagComponent } from '../../../components/status-tag/status-tag.component';
import { ExceptionsService } from '../../../services/http/exceptions/exceptions.service';
import { AccessService } from '../../../services/http/access/access.service';
import { VehicleIcconResumeComponent } from '../../../components/vehicle-iccon-resume/vehicle-iccon-resume.component';
import { DialogService } from '../../../services/dialog/dialog.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { MunicipalitiesService } from '../../../services/http/municipalities/municipalities.service';
import { MunicipalityManagement } from '../../../services/http/municipalities/municipalities.interface';

@Component({
  selector: 'app-vehicles-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, StatusTagComponent, VehicleIcconResumeComponent],
  templateUrl: './vehicles-detail.component.html',
  styleUrl: './vehicles-detail.component.scss'
})
export class VehiclesDetailComponent implements OnInit {
  plate = '';
  vehicle: Vehicle | null = null;
  vehicles: Vehicle[] = [];
  vehiclesTypes: any[] = [];
  statuses: string[] = [];
  exceptionsList: Exception[] = [];
  accessList: AccessVehicleResponse | undefined;
  municipalities: MunicipalityManagement[] = [];

  muniAccesses: any[] = [];
  totalAccesses = 10;

  constructor(
    private readonly vehiclesService: VehiclesService,
    private exceptionsService: ExceptionsService,
    private accessService: AccessService,
    private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly activeRoute: ActivatedRoute,
    private readonly dialogService: DialogService,
    private readonly loaderService: LoaderService,
    private readonly municipalitiesService: MunicipalitiesService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.vehiclesService.getVehicleTypes().subscribe((data: VehicleTypeResponse) => {
      this.vehiclesTypes = data.registrations;
    });
    for (const key of Object.keys(ExceptionStatus)) {
      this.statuses.push(key);
    }
  }

  ngOnInit(): void {
    this.plate = this.activeRoute.snapshot.paramMap.get('plate') || '';
    if (this.plate !== '') {
      this.loaderService.show();
      this.vehiclesService.getVehicle(this.plate).subscribe((vehicle: Vehicle) => {
        this.vehicle = vehicle;
        this.loaderService.hide();
      });
      this.exceptionsService.getExceptions(this.plate).subscribe((exceptionsList: any) => {
        this.exceptionsList = exceptionsList.elements;
      });
      this.accessService.getAccessesByVehicle(this.plate).subscribe((accessesList) => {
        this.accessList = accessesList;
      });
      this.vehiclesService.getVehiclees().subscribe((vehicles: VehiclesResponse) => {
        this.vehicles = vehicles.elements;
      });
      this.municipalitiesService.getMunicipalitiesManagement().subscribe((municipalities) => {
        this.municipalities = municipalities.municipalities;
        this.municipalities.forEach(muni => {
          this.accessService.getAccessesByVehicleMunicipality(this.plate, muni.municipality.municipalityName).subscribe((accessesList) => {
            this.muniAccesses.push({
              name: muni.municipality.municipalityName,
              total: accessesList.total,
              percentaje: 'width: ' + ((accessesList.total / this.totalAccesses) * 100) + '%',
              class: this.getClass((accessesList.total / this.totalAccesses) * 100)
            });
          });
        });
      });
    }
  }

  getClass(percentaje: number) {
    if (percentaje < 60) {
      return 'bg-success';
    } else if (percentaje < 80) {
      return 'bg-warning';
    } else {
      return 'bg-danger';
    }
  }

  goToEditVehicle() {
    this.router.navigate(['vehicles', this.plate, 'edit']);
  }

  deleteVehicle() {
    this.dialogService.setDialog({
      title: $localize`:@@Vehicles.Detail.DeleteVehicle:Eliminar vehículo`,
      message: $localize`:@@Vehicles.Detail.DeleteVehicleMessage:¿Está seguro que desea eliminar el vehículo?`,
      button1Text: $localize`:@@Shared.Cancel:Cancelar`,
      button2Text: $localize`:@@Shared.Delete:Eliminar`,
      button1Callback: () => {
        this.dialogService.clearDialog();
      },
      button2Callback: () => {
        this.loaderService.show();
        this.vehiclesService.deleteVehicle(this.plate).subscribe((success: string) => {
          this.alertService.setAlert({
            message: $localize`:@@Vehicles.Detail.Deleted:Vehículo eliminado correctamente`,
            type: AlertType.Success,
            dismissible: true,
            dismissOnTimeout: 2000
          } as Alert);
          this.loaderService.hide();
          this.router.navigate([`/vehicles/`]);
        });
      }
    });
  }

  newAutorization() {
    this.router.navigate(['exceptions', this.plate, 'new']);
  }

  goToEditException(id: string) {
    this.router.navigate(['vehicles', this.plate, 'exceptions', id]);
  }

  newVehicle() {
    this.router.navigate(['/vehicles/new']);
  }

  goToViewVehicle(plate: string) {
    this.router.navigate(['/vehicles', plate]);
    this.vehiclesService.getVehicle(plate).subscribe((vehicle: Vehicle) => {
      this.vehicle = vehicle;
      this.document.body.scrollTop = 0;
      this.document.documentElement.scrollTop = 0;
    });
  }

  goBack() {
    this.router.navigate(['/vehicles']);
  }
}
